import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export interface ModalState {
  show: string
  showNavMobile: boolean
  showFilter: boolean
  loading: boolean
  isSearching: boolean
  searchString: string
}

export const useModalStore = defineStore('modal', () => {
    // State using ref
    const show = ref('');
    const showNavMobile = ref(false);
    const showFilter = ref(false);
    const loading = ref(false);
    const isSearching = ref(false);
    const searchString = ref('');

    // Getters using computed
    const showModal = computed(() => (type: string) => show.value === type);
    const getShowNavMobile = computed(() => showNavMobile.value);
    const getShowFilter = computed(() => showFilter.value);
    const isLoading = computed(() => loading.value);
    const getIsSearching = computed(() => isSearching.value);
    const getSearch = computed(() => searchString.value);

    // Actions as regular functions
    function showModalAction(type: string) {
        show.value = type;
    }

    function hideModal() {
        show.value = '';
    }

    function toggleNavMobile() {
        showNavMobile.value = !showNavMobile.value;
    }

    function toggleFilter() {
        showFilter.value = !showFilter.value;
    }

    function startLoading() {
        loading.value = true;
    }

    function stopLoading() {
        loading.value = false;
    }

    function doSearch() {
        isSearching.value = !isSearching.value;
    }

    function setSearch(data: string) {
        const dataLayer = (window as any).dataLayer || [];
        dataLayer.push({
            event: 'kwastSearch',
            eventModel: {
                searchQuery: data,
            },
        });
        searchString.value = data;
    }

    return {
    // State
        show,
        showNavMobile,
        showFilter,
        loading,
        isSearching,
        searchString,
        // Getters
        showModal,
        getShowNavMobile,
        getShowFilter,
        isLoading,
        getIsSearching,
        getSearch,
        // Actions
        showModalAction,
        hideModal,
        toggleNavMobile,
        toggleFilter,
        startLoading,
        stopLoading,
        doSearch,
        setSearch,
    };
}); 
